import { forwardRef, ForwardedRef } from 'react'
import { twMerge } from 'tailwind-merge'

interface SpinnerProps {
  fullScreen?: boolean | undefined
  className?: string | undefined
  color?: string
}

export const Spinner = forwardRef(
  function Spinner ({ className, fullScreen, color = 'bg-pink-500' }: SpinnerProps, ref: ForwardedRef<HTMLDivElement>) {
    return (
      <div
        ref={ref}
        className={twMerge(
          'core-spinner',
          'flex h-12 w-12 items-center justify-center',
          fullScreen === true && 'h-screen',
          className
        )}
      >
        <div className='relative inline-block h-full w-full'>
          <div className={twMerge(color, 'absolute left-2 inline-block w-2 animate-jump [animation-delay:-.24s]')} />
          <div className={twMerge(color, 'absolute left-5 inline-block w-2 animate-jump [animation-delay:-.12s]')} />
          <div className={twMerge(color, 'absolute left-8 inline-block w-2 animate-jump ')} />
        </div>
      </div>
    )
  }
)
